import { useState } from 'react';

/**
 * UseCopyToClipboard.
 * @returns
 */
export function useCopyToClipboard() {
  const [copied, setCopied] = useState(false);

  const copy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
  };

  const reset = () => setCopied(false);

  return { copy, copied, reset };
}
